module.exports = __webpack_public_path__ + "static/media/mybarbell-icon.33a5e3c8.png";